import { createRouter, createWebHistory, } from 'vue-router';
import AdvancedSearch from './components/AdvancedSearch.vue';
import actionDocuments from './components/actionDocuments.vue';
import AdminPanel from './components/admin/AdminPanel.vue';
import AdminAssignView from './components/adminAssignView.vue';
import allDocuments from './components/allDocuments.vue';
import ApprovalPage from './components/approvalPage.vue';
import ApproveAmend from './components/approveAmend.vue';
import CompleteAmend from './components/CompleteAmend.vue';
import ConfirmAmend from './components/ConfirmAmend.vue';
import ConfirmLeaver from './components/ConfirmLeaver.vue';
import ConfirmOffer from './components/confirmOffer.vue';
import CreateAmend from './components/createAmend.vue';
import CreateLeaver from './components/createLeaver.vue';
import CreateStarter from './components/createStarter.vue';
import indexView from './components/indexView.vue';
import LeaverAssignView from './components/leaverAssignView.vue';
import LeaverCompleteView from './components/leaverCompleteView.vue';
import LogoutComponent from './components/logoutComponent.vue';
import offerView from './components/offerView.vue';
import profileView from './components/profileView.vue';
import ReAssign from './components/ReAssign.vue';
import ResourcingDashboard from './components/ResourcingDashboard.vue';
import RespondMoreInfo from './components/RespondMoreInfo.vue';
import searchResults from './components/searchResults.vue';
import ViewAllDocs from './components/ViewAllDocs.vue';
import AssignAdminOwner from './components/workflowForms/AssignAdminOwner.vue';
import RecruitmentUpdate from './components/workflowForms/RecruitmentUpdate.vue';
import SapConfirmation from './components/workflowForms/SapConfirmation.vue';
import recruitmentNotify from './components/workflowForms/step4RecruitmentTeam.vue';
import advertRaised from './components/workflowForms/step5AdvertRaised.vue';
import readyForSelection from './components/workflowForms/step6ReadyForSelection.vue';
import selectionComplete from './components/workflowForms/step7SelectionComplete.vue';
import recruitmentFeedback from './components/workflowForms/step8RecruitmentFeedback.vue';
import offerHr from './components/workflowForms/step13OfferHR.vue';
import flApproval from './components/workflowForms/step14OfferFLA.vue';
import slApproval from './components/workflowForms/step15OfferSLA.vue';
import store from './store';
// Permission check function (used by route-specific beforeEnter guards)
const isPermitted = (roles) => {
    const profile = store.getters.getProfile;
    let allowed = false;
    roles.forEach((role) => {
        if (profile[role]) {
            allowed = true;
        }
    });
    return allowed;
};
// Route definitions
const routeInfos = [
    {
        name: 'Home',
        path: '/',
        component: indexView,
        meta: {
            title: 'Equans Slam - Home',
            metaTags: [
                {
                    name: 'description',
                    content: 'Equans SLAM home page - Starters, Leavers and Movers management system',
                },
            ],
        },
    },
    {
        name: 'Advanced Search',
        path: '/search',
        component: AdvancedSearch,
        meta: {
            title: 'Equans Slam - Advanced Search',
            metaTags: [
                {
                    name: 'description',
                    content: 'Advanced search for SLAM requests and documents',
                },
            ],
        },
    },
    {
        name: 'Search Results',
        path: '/search-results/:docType/:searchString',
        component: searchResults,
        meta: {
            title: 'Equans Slam - Search Results',
            metaTags: [
                {
                    name: 'description',
                    content: 'Search results for SLAM requests',
                },
            ],
        },
    },
    {
        name: 'Resourcing',
        path: '/resourcing',
        component: ResourcingDashboard,
        meta: {
            title: 'Equans Slam - Resourcing Dashboard',
            metaTags: [
                {
                    name: 'description',
                    content: 'Resourcing dashboard for managing recruitment activities',
                },
            ],
        },
        beforeEnter: (_to, _from, next) => {
            if (isPermitted(['H2R', 'ADMIN', 'RESOURCING'])) {
                next();
            }
            else {
                next('/');
            }
        },
    },
    {
        name: 'All Requests',
        path: '/all-documents',
        component: ViewAllDocs,
        meta: {
            title: 'Equans Slam - All Requests',
            metaTags: [
                {
                    name: 'description',
                    content: 'View all SLAM requests across the organisation',
                },
            ],
        },
        beforeEnter: (_to, _from, next) => {
            if (isPermitted(['H2R', 'ADMIN', 'RESOURCING'])) {
                next();
            }
            else {
                next('/');
            }
        },
    },
    {
        name: 'Your Requests',
        path: '/all-my-documents',
        component: allDocuments,
        meta: {
            title: 'Equans Slam - Your Requests',
            metaTags: [
                {
                    name: 'description',
                    content: 'View your submitted SLAM requests',
                },
            ],
        },
    },
    {
        name: 'Assigned Approvals',
        path: '/action-documents',
        component: actionDocuments,
        meta: {
            title: 'Equans Slam - Assigned Approvals',
            metaTags: [
                {
                    name: 'description',
                    content: 'View requests assigned to you for approval',
                },
            ],
        },
    },
    {
        name: 'Create Starter',
        path: '/create-starter/:id',
        component: CreateStarter,
        meta: {
            title: 'Equans Slam - Create Starter',
            metaTags: [
                {
                    name: 'description',
                    content: 'Create a new Authority to Recruit (ATR) request',
                },
            ],
        },
    },
    {
        name: 'View ATR',
        path: '/view-starter/:id/:docOwner',
        component: CreateStarter,
        meta: {
            title: 'Equans Slam - View ATR',
            metaTags: [
                {
                    name: 'description',
                    content: 'View Authority to Recruit (ATR) request details',
                },
            ],
        },
    },
    {
        name: 'Create Leaver',
        path: '/create-leaver/:id',
        component: CreateLeaver,
        meta: {
            title: 'Equans Slam - Create Leaver',
            metaTags: [
                {
                    name: 'description',
                    content: 'Create a new leaver request',
                },
            ],
        },
    },
    {
        name: 'View leaver',
        path: '/view-leaver/:id/:docOwner',
        component: CreateLeaver,
        meta: {
            title: 'Equans Slam - View Leaver',
            metaTags: [
                {
                    name: 'description',
                    content: 'View leaver request details',
                },
            ],
        },
    },
    {
        name: 'Create Amendment',
        path: '/create-amend',
        component: CreateAmend,
        meta: {
            title: 'Equans Slam - Create Amendment',
            metaTags: [
                {
                    name: 'description',
                    content: 'Create a new employment amendment request',
                },
            ],
        },
    },
    {
        name: 'View Amend',
        path: '/view-amend/:id/:docOwner',
        component: CreateAmend,
        meta: {
            title: 'Equans Slam - View Amendment',
            metaTags: [
                {
                    name: 'description',
                    content: 'View employment amendment request details',
                },
            ],
        },
    },
    {
        name: 'Approval Workflow',
        path: '/approve-workflow/:action',
        component: ApprovalPage,
        meta: {
            title: 'Equans Slam - Approval Workflow',
            metaTags: [
                {
                    name: 'description',
                    content: 'Process approval workflow actions',
                },
            ],
        },
    },
    {
        name: 'Approve Amend',
        path: '/approve-amend/:id/:docOwner',
        component: ApproveAmend,
        meta: {
            title: 'Equans Slam - Approve Amendment',
            metaTags: [
                {
                    name: 'description',
                    content: 'Approve an employment amendment request',
                },
            ],
        },
    },
    {
        name: 'Complete Amend',
        path: '/complete-amend/:id/:docOwner',
        component: CompleteAmend,
        meta: {
            title: 'Equans Slam - Complete Amendment',
            metaTags: [
                {
                    name: 'description',
                    content: 'Complete an employment amendment request',
                },
            ],
        },
    },
    {
        name: 'Confirm Amendment',
        path: '/confirm-amend/:docId/:requestedBy',
        component: ConfirmAmend,
        meta: {
            title: 'Equans Slam - Confirm Amendment',
            metaTags: [
                {
                    name: 'description',
                    content: 'Confirm an employment amendment request',
                },
            ],
        },
    },
    {
        name: 'Confirm leaver',
        path: '/confirm-leaver/:docId/:requestedBy',
        component: ConfirmLeaver,
        meta: {
            title: 'Equans Slam - Confirm Leaver',
            metaTags: [
                {
                    name: 'description',
                    content: 'Confirm a leaver request',
                },
            ],
        },
    },
    {
        name: 'Confirm Offer',
        path: '/confirm/:id/:docOwner',
        component: ConfirmOffer,
        meta: {
            title: 'Equans Slam - Confirm Offer',
            metaTags: [
                {
                    name: 'description',
                    content: 'Confirm a job offer',
                },
            ],
        },
    },
    {
        name: 'Amend terms',
        path: '/amend-terms/:id/:docOwner',
        component: ConfirmOffer,
        meta: {
            title: 'Equans Slam - Amend Terms',
            metaTags: [
                {
                    name: 'description',
                    content: 'Amend job offer terms',
                },
            ],
        },
    },
    {
        name: 'Assign Leaver admin',
        path: '/assign-leaver-admin/:docId/:requestedBy',
        component: LeaverAssignView,
        meta: {
            title: 'Equans Slam - Assign Leaver Admin',
            metaTags: [
                {
                    name: 'description',
                    content: 'Assign an admin to process a leaver request',
                },
            ],
        },
    },
    {
        name: 'Complete leaver',
        path: '/complete-leaver/:docId/:docOwner',
        component: LeaverCompleteView,
        meta: {
            title: 'Equans Slam - Complete Leaver',
            metaTags: [
                {
                    name: 'description',
                    content: 'Complete a leaver request',
                },
            ],
        },
    },
    {
        name: 'Assign Amend Admin',
        path: '/admin-assign-amend/:id/:docOwner',
        component: AdminAssignView,
        meta: {
            title: 'Equans Slam - Assign Amend Admin',
            metaTags: [
                {
                    name: 'description',
                    content: 'Assign an admin to process an amendment request',
                },
            ],
        },
    },
    {
        name: 'Re-assign Document',
        path: '/re-assign/:id/:docOwner',
        component: ReAssign,
        meta: {
            title: 'Equans Slam - Re-assign Document',
            metaTags: [
                {
                    name: 'description',
                    content: 'Re-assign a document to another user',
                },
            ],
        },
        beforeEnter: (_to, _from, next) => {
            if (isPermitted(['H2R', 'ADMIN', 'RESOURCING'])) {
                next();
            }
            else {
                next('/');
            }
        },
    },
    {
        name: 'Respond to more info',
        path: '/more-info/:docId/:requestedBy',
        component: RespondMoreInfo,
        meta: {
            title: 'Equans Slam - More Information',
            metaTags: [
                {
                    name: 'description',
                    content: 'Respond to a request for more information',
                },
            ],
        },
    },
    {
        name: 'View Offer',
        path: '/view-offer/:id/:docOwner',
        component: offerView,
        meta: {
            title: 'Equans Slam - View Offer',
            metaTags: [
                {
                    name: 'description',
                    content: 'View job offer details',
                },
            ],
        },
    },
    {
        name: 'Profile',
        path: '/profile',
        component: profileView,
        meta: {
            title: 'Equans Slam - Profile',
            metaTags: [
                {
                    name: 'description',
                    content: 'View and manage your user profile',
                },
            ],
        },
    },
    {
        name: 'Admin Panel',
        path: '/admin',
        component: AdminPanel,
        meta: {
            title: 'Equans Slam - Admin Panel',
            metaTags: [
                {
                    name: 'description',
                    content: 'Administration panel for system management',
                },
            ],
        },
        beforeEnter: (_to, _from, next) => {
            if (isPermitted(['H2R', 'ADMIN'])) {
                next();
            }
            else {
                next('/');
            }
        },
    },
    {
        name: 'Assign Admin Owner',
        path: '/assign-admin-owner/:id/:docOwner',
        component: AssignAdminOwner,
        meta: {
            title: 'Equans Slam - Assign Admin Owner',
            metaTags: [
                {
                    name: 'description',
                    content: 'Assign an admin owner to a request',
                },
            ],
        },
    },
    {
        name: 'Recruitment Team',
        path: '/recruitment-update/:id/:docOwner',
        component: recruitmentNotify,
        meta: {
            title: 'Equans Slam - Recruitment Team',
            metaTags: [
                {
                    name: 'description',
                    content: 'Notify recruitment team about a request',
                },
            ],
        },
    },
    {
        name: 'Sap confirmation',
        path: '/sap-confirmation/:id/:docOwner',
        component: SapConfirmation,
        meta: {
            title: 'Equans Slam - SAP Confirmation',
            metaTags: [
                {
                    name: 'description',
                    content: 'Confirm SAP integration details',
                },
            ],
        },
    },
    {
        name: 'Advert Raised',
        path: '/advert-raised/:id/:docOwner',
        component: advertRaised,
        meta: {
            title: 'Equans Slam - Advert Raised',
            metaTags: [
                {
                    name: 'description',
                    content: 'Record that a job advert has been raised',
                },
            ],
        },
    },
    {
        name: 'Ready For Selection',
        path: '/ready-for-selection/:id/:docOwner',
        component: readyForSelection,
        meta: {
            title: 'Equans Slam - Ready For Selection',
            metaTags: [
                {
                    name: 'description',
                    content: 'Mark a request as ready for candidate selection',
                },
            ],
        },
    },
    {
        name: 'Selection Complete',
        path: '/selection-complete/:id/:docOwner',
        component: selectionComplete,
        meta: {
            title: 'Equans Slam - Selection Complete',
            metaTags: [
                {
                    name: 'description',
                    content: 'Record that candidate selection is complete',
                },
            ],
        },
    },
    {
        name: 'Recruitment Details',
        path: '/recruitment-team/:id/:docOwner',
        component: RecruitmentUpdate,
        meta: {
            title: 'Equans Slam - Recruitment Details',
            metaTags: [
                {
                    name: 'description',
                    content: 'Update recruitment details for a request',
                },
            ],
        },
    },
    {
        name: 'Recruitment Feedback',
        path: '/recruitment-feedback',
        component: recruitmentFeedback,
        meta: {
            title: 'Equans Slam - Recruitment Feedback',
            metaTags: [
                {
                    name: 'description',
                    content: 'Provide feedback on recruitment process',
                },
            ],
        },
    },
    {
        name: 'Offer HR',
        path: '/offer-hr/:id/:docOwner',
        component: offerHr,
        meta: {
            title: 'Equans Slam - Offer HR',
            metaTags: [
                {
                    name: 'description',
                    content: 'HR processing for job offers',
                },
            ],
        },
    },
    {
        name: 'First Line',
        path: '/first-line-approval',
        component: flApproval,
        meta: {
            title: 'Equans Slam - First Line Approval',
            metaTags: [
                {
                    name: 'description',
                    content: 'First line approval for job offers',
                },
            ],
        },
    },
    {
        name: 'Second Line',
        path: '/second-line-approval',
        component: slApproval,
        meta: {
            title: 'Equans Slam - Second Line Approval',
            metaTags: [
                {
                    name: 'description',
                    content: 'Second line approval for job offers',
                },
            ],
        },
    },
    {
        name: 'Logout',
        path: '/logout',
        component: LogoutComponent,
        meta: {
            title: 'Equans Slam - Logout',
        },
    },
];
// Create router instance
const router = createRouter({
    history: createWebHistory(),
    routes: routeInfos,
});
// Navigation guard for meta tags (permission checking done via route-specific beforeEnter guards)
router.beforeEach((to, from, next) => {
    // Find the nearest matched route with a title (searching from most specific to least)
    const nearestWithTitle = to.matched
        .slice()
        .reverse()
        .find((r) => r.meta?.title);
    // Find the nearest matched route with metaTags
    const nearestWithMeta = to.matched
        .slice()
        .reverse()
        .find((r) => r.meta?.metaTags);
    // Find the previous route with title for fallback
    const previousNearestWithMeta = from.matched
        .slice()
        .reverse()
        .find((r) => r.meta?.title);
    // Set document title (with fallback to previous route's title)
    if (nearestWithTitle) {
        document.title = nearestWithTitle.meta.title;
    }
    else if (previousNearestWithMeta) {
        document.title = previousNearestWithMeta.meta.title;
    }
    // Remove existing meta tags with data-vue-router-controlled attribute
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).forEach((el) => {
        el.remove();
    });
    // Skip meta tag injection if no metaTags defined
    if (!nearestWithMeta) {
        return next();
    }
    // Inject new meta tags with data-vue-router-controlled attribute
    const metaTags = nearestWithMeta.meta.metaTags;
    metaTags.forEach((tagDef) => {
        const tag = document.createElement('meta');
        Object.keys(tagDef).forEach((key) => {
            tag.setAttribute(key, tagDef[key]);
        });
        tag.setAttribute('data-vue-router-controlled', '');
        document.head.appendChild(tag);
    });
    next();
});
export default router;
